import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CodeWrapper = styled.div`
  margin-top: 2rem;
`;

const codeStyle = {
  'code[class*="language-"]': {
    color: '#f5f6f7',
    textShadow: 'none',
    fontFamily:
      "Noto Mono, Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
    fontSize: '1rem',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
  },
  'pre[class*="language-"]': {
    color: '#f5f6f7',
    textShadow: 'none',
    fontFamily:
      "Noto Mono, Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
    fontSize: '1rem',
    direction: 'ltr',
    textAlign: 'left',
    whiteSpace: 'pre',
    wordSpacing: 'normal',
    wordBreak: 'normal',
    lineHeight: '1.5',
    MozTabSize: '4',
    OTabSize: '4',
    tabSize: '4',
    WebkitHyphens: 'none',
    MozHyphens: 'none',
    msHyphens: 'none',
    hyphens: 'none',
    padding: '1rem',
    margin: '0',
    overflow: 'auto',
    borderRadius: '0 0 0.125rem 0.125rem',
    background: '#12212b',
  },
  ':not(pre) > code[class*="language-"]': {
    background: '#12212b',
    padding: '0.1rem',
    borderRadius: '0.125rem',
  },
  comment: {
    color: '#a6b1ba',
  },
  prolog: {
    color: '#a6b1ba',
  },
  doctype: {
    color: '#a6b1ba',
  },
  cdata: {
    color: '#a6b1ba',
  },
  punctuation: {
    color: '#A6B1BA',
  },
  '.namespace': {
    Opacity: '.7',
  },
  property: {
    color: '#fc5f6a',
  },
  keyword: {
    color: '#75d2cc',
  },
  tag: {
    color: '#FBB060',
  },
  'class-name': {
    color: '#74bced',
  },
  boolean: {
    color: '#fc5f6a',
  },
  constant: {
    color: '#fc5f6a',
  },
  symbol: {
    color: '#fc5f6a',
  },
  deleted: {
    color: '#fc5f6a',
  },
  number: {
    color: '#fc5f6a',
  },
  selector: {
    color: '#b6ed8e',
  },
  'attr-name': {
    color: '#b6ed8e',
  },
  string: {
    color: '#b6ed8e',
  },
  char: {
    color: '#b6ed8e',
  },
  builtin: {
    color: '#b6ed8e',
  },
  inserted: {
    color: '#b6ed8e',
  },
  variable: {
    color: '#1ea8a1',
  },
  operator: {
    color: '#fffa94',
  },
  entity: {
    color: '#fffa94',
    cursor: 'help',
  },
  url: {
    color: '#fffa94',
  },
  '.language-css .token.string': {
    color: '#fffa94',
  },
  '.style .token.string': {
    color: '#fffa94',
  },
  atrule: {
    color: '#75d2cc',
  },
  'attr-value': {
    color: '#75d2cc',
  },
  function: {
    color: '#74bced',
  },
  regex: {
    color: '#1ea8a1',
  },
  important: {
    color: '#1ea8a1',
    fontWeight: 'bold',
  },
  bold: {
    fontWeight: 'bold',
  },
  italic: {
    fontStyle: 'italic',
  },
};

const CodeSample = ({ componentString, language = 'jsx' }) => (
  <CodeWrapper>
    <SyntaxHighlighter
      language={language}
      wrapLines
      codeTagProps={{ style: { fontFamily: 'Noto Mono' } }}
      style={codeStyle}
    >
      {componentString}
    </SyntaxHighlighter>
  </CodeWrapper>
);

CodeSample.propTypes = {
  componentString: PropTypes.string,
  language: PropTypes.string,
};

export default CodeSample;
